export default __webpack_public_path__ + "static/media/close.79c06ad8.svg";